module.exports = __webpack_public_path__ + "img/pr-11.f8a6aaed.png";